import React from "react";
import { useTranslation } from "react-i18next";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

// Footer data no longer contains any hard-coded labels or titles,
// only the URLs and anything immutable.
const footerData = {
  about: {
    siteName: "UpConstruction",
    address: ["A108 Adam Street", "New York, NY 535022"],
    phone: "+1 5589 55488 55",
    email: "info@example.com"
  },
  usefulLinks: [
    { label: "Home", to: "/" },
    { label: "About us", to: "/" },
    { label: "Impressum", to: "/impressum" },
    { label: "Privacy policy", to: "/privacy-policy" },
    { label: "Terms of service", to: "/" }
  ],
  servicesLinks: [
    "Web Design",
    "Web Development",
    "Product Management",
    "Marketing",
    "Graphic Design"
  ],
  extraLinks: [
    "Molestiae accusamus iure",
    "Excepturi dignissimos",
    "Suscipit distinctio",
    "Dilecta",
    "Sit quas consectetur"
  ],
  illumLinks: ["Ipsam", "Laudantium dolorum", "Dinera", "Trodelas", "Flexo"],
  social: [
    { icon: <FaTwitter aria-hidden="true" />, url: "#", label: "Twitter" },
    { icon: <FaFacebook aria-hidden="true" />, url: "#", label: "Facebook" },
    { icon: <FaInstagram aria-hidden="true" />, url: "#", label: "Instagram" },
    { icon: <FaLinkedin aria-hidden="true" />, url: "#", label: "LinkedIn" }
  ],
  copyright: {
    owner: "LeistFusion"
  }
};

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-12 col-md-6 col-lg-4 footer-about">
            <Link to="/" className="logo d-flex align-items-center">
              <span className="sitename">{footerData.about.siteName}</span>
            </Link>
            <div className="footer-contact pt-3">
              {footerData.about.address.map((line, idx) => (
                <p key={idx}>{line}</p>
              ))}
              <p className="mt-3">
                <strong>Phone:</strong> <span>{footerData.about.phone}</span>
              </p>
              <p>
                <strong>Email:</strong> <span>{footerData.about.email}</span>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              {footerData.social.map(({ icon, url, label }, idx) => (
                <a key={idx} href={url} aria-label={label}>
                  {icon}
                </a>
              ))}
            </div>
          </div>

          <FooterSection
            title="Useful Links"
            links={footerData.usefulLinks.map(link => ({ label: link.label, to: link.to }))}
            isRouter
          />
          <FooterSection
            title="Our Services"
            links={footerData.servicesLinks.map(item => ({ label: item, to: "#" }))}
          />
          <FooterSection
            title="Hic solutasetp"
            links={footerData.extraLinks.map(item => ({ label: item, to: "#" }))}
          />
          <FooterSection
            title="Nobis illum"
            links={footerData.illumLinks.map(item => ({ label: item, to: "#" }))}
          />
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">{footerData.copyright.owner}</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
};

const FooterSection = ({ title, links, isRouter = false }) => (
  <div className="col-6 col-md-3 col-lg-2 footer-links">
    <h2 className="footer-links__title text-white">{title}</h2>
    <ul>
      {links.map(({ label, to }, idx) => (
        <li key={idx}>{isRouter ? <Link to={to}>{label}</Link> : <a href={to}>{label}</a>}</li>
      ))}
    </ul>
  </div>
);

export default Footer;
